import React from "react";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  Select,
  Link,
  SearchableList,
  MultiSelectDropdown,
} from "../../../components";
import { getTwoDecimalPlaces } from "../../../utils";
const columns = [
  {
    label: "Particulars",
    className: "column-planName col-md-3",
    columnName: "particulars",
  },
  {
    label: "Opening balance",
    className: "column-status col-md-3",
    columnName: "openingBalance",
  },
  {
    label: "Transactions",
    className: "column-status col-md-3",
    columnName: "transactionsForPeriod",
  },
  {
    label: "Closing balance",
    className: "column-status col-md-3",
    columnName: "closingBalance",
  },
];
const data = [
  {
    particulars: "Employer Contribution Account",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Employer Contribution - Vested A/C",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Employer Contribution - Unvested A/C",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
];
const total = {
  particulars: "Total",
  openingBalance: 340123,
  transactionsForPeriod: 102123,
  closingBalance: 442246,
};
export const ContributionStatementTable = (props) => {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {columns.map((e, i) => (
            <Table.Th className="table-width-25">{e.label}</Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {data.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className="table-width-25">
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className="table-width-25">
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "particulars" ? (
              <Table.Td className={`${f.className} table-total-value`}>
                {total[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className={`${f.className} table-total-value`}>
                ${getTwoDecimalPlaces(total[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
      </Table.Tbody>
    </Table>
  );
};
